module.exports = __webpack_public_path__ + "static/media/ACOSO.22ff3524.jpg";